
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-supplier",
      function () {
        return require("private-next-pages/become-a-supplier.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-a-supplier"])
      });
    }
  